import inboxService from "./inboxService";

const inboxServices = [
    ...inboxService
]

export default inboxServices;